import React, { Component } from "react";
import Cookies from "universal-cookie";
import { dealerApiService } from "../../services/otodis/DealerApiService";
import { Form, Select } from "antd";
import { Buffer } from "buffer";

const { Option } = Select;

const cookies = new Cookies();
const listIamDealer = cookies.get("_d") ? JSON.parse(Buffer.from(cookies.get("_d"), "base64").toString()) : [];

class SelectDealer extends Component<any, any> {
  initState = {
    dataOption: [],
  };
  state = { ...this.initState };

  componentDidMount = async () => {
    try {
      const dataDealer = await dealerApiService.getDealer({ lite_respon: "false" });

      let listOption = dataDealer.data.data.map((d: any) => {
        return { dealer_code: d.dealer_code, dealer_name: d.dealer_name, address: d.address, email: d.email, phone: d.phone };
      });

      this.setState({
        dataOption: listOption,
      });
    } catch (error) {
      this.setState({
        dataOption: [],
      });
    }
  };

  render() {
    return (
      <Form.Item label={this.props.label} className="col-lg-12">
        <Select style={{ fontSize: "85%", minWidth: "200px" }} placeholder={"Pilih " + this.props.label} onChange={this.props.onChangeValue} value={this.props.value}>
          {this.state.dataOption.map((d: any, i) => {
            const picked = listIamDealer.find((o: { DealerCode: string }) => o.DealerCode === d.dealer_code);
            if (picked) {
              return (
                <Option key={d.dealer_code} value={d.dealer_code} add_text={d.address + "#" + d.email + "#" + d.phone}>
                  {d.dealer_name}
                </Option>
              );
            } else {
              return null;
            }
          })}
        </Select>
      </Form.Item>
    );
  }
}

export default SelectDealer;
